import { render, staticRenderFns } from "./WorkCardDiagnostic.vue?vue&type=template&id=dd21b4d0&scoped=true&lang=pug"
import script from "./WorkCardDiagnostic.vue?vue&type=script&lang=js"
export * from "./WorkCardDiagnostic.vue?vue&type=script&lang=js"
import style0 from "./WorkCardDiagnostic.vue?vue&type=style&index=0&id=dd21b4d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd21b4d0",
  null
  
)

export default component.exports